export const docTypeNameMap = {
	work_contract: "__hiring_process__work_contract__",
	job_description: "__hiring_process__job_description__",
	admission_app: "__hiring_process__admission_app__",
	material_responsibility: "__hiring_process__material_responsibility__",
	conflict_of_interest: "__hiring_process__conflict_of_interest__",
	admission_order: "__hiring_process__admission_order__",
	process_duty: "__hiring_process__duty__",
	civil_contract: "__hiring_process__civil_contract__",
	service_delivery_agreement: "__hiring_process__service_delivery_agreement__",
	firing_application: "__firing_process__firing_application__",
	notify: "__firing_process__notify__",
	firing_order_with_contract: "__firing_process__firing_order_with_contract__",
	changes_report: "__hiring_process__changes_report__",
	changes_additional_contract: "__hiring_process__changes_additional_contract__",
	// Added new fields for procurement (expences)
	demand_letter: "__procurement__demand_letter__",
	supplier_contract: "__procurement__supplier_contract__",
	additional_supplier_contract: "__procurement__additional_supplier_contract__",
	additional_contract: "__procurement__additional_contract__",
	act_of_acceptance: "__procurement__act_of_acceptance__",
	additional_act: "__procurement__additional_act__",
	// Added new fields for service delivery
	service_demand_letter: "__procurement__service_demand_letter__",
	service_delivery_contract: "__procurement__service_delivery_contract__",
	additional_service_contract: "__procurement__additional_service_contract__",
	additional_service_acceptance: "__procurement__additional_service_acceptance__",
	act_of_service_acceptance: "__procurement__act_of_service_acceptance__",
	additional_act_of_service_acceptance: "__procurement__additional_act_of_service_acceptance__",
	// Added new fields for cable procurement
	cable_contract: "__procurement__cable_contract__",
	additional_cable_contract: "__procurement__additional_cable_contract__",
	act_of_cable_acceptance: "__procurement__act_of_cable_acceptance__",
};

export const NodeService = [
	{
		key: "0",
		data: {
			name: "__hiring_process__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0",
				data: {
					name: "__hiring_process__official__",
					size: "200kb",
					type: "Folder",
				},
				children: [
					{
						key: "0-0-0",
						data: {
							row: "work_contract",
							name: "__hiring_process__work_contract__",
							is_position_related: false,
						},
					},
					{
						key: "0-0-1",
						data: {
							row: "job_description",
							name: "__hiring_process__job_description__",
							is_position_related: true,
						},
					},
					{
						key: "0-0-2",
						data: {
							row: "admission_app",
							name: "__hiring_process__admission_app__",
							is_position_related: false,
						},
					},
					{
						key: "0-0-3",
						data: {
							row: "material_responsibility",
							name: "__hiring_process__material_responsibility__",
							is_position_related: false,
						},
					},
					{
						key: "0-0-4",
						data: {
							row: "conflict_of_interest",
							name: "__hiring_process__conflict_of_interest__",
							is_position_related: false,
						},
					},
					{
						key: "0-0-5",
						data: {
							row: "admission_order",
							name: "__hiring_process__admission_order__",
							is_position_related: false,
						},
					},
					{
						key: "0-0-6",
						data: {
							row: "process_duty",
							name: "__hiring_process__duty__",
							is_position_related: false,
						},
					},
				],
			},
			{
				key: "0-1",
				data: {
					name: "__hiring_process__civil__",
					size: "200kb",
					type: "Folder",
				},
				children: [
					{
						key: "0-1-0",
						data: {
							row: "civil_contract",
							name: "__hiring_process__civil_contract__",
							is_position_related: false,
						},
					},
					{
						key: "0-1-1",
						data: {
							row: "service_delivery_agreement",
							name: "__hiring_process__service_delivery_agreement__",
							is_position_related: false,
						},
					},
				],
			},
		],
	},
	{
		key: "1",
		data: {
			name: "__firing_process__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0-0",
				data: {
					row: "firing_application",
					name: "__firing_process__firing_application__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-1",
				data: {
					row: "firing_order",
					name: "__firing_process__firing_order__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-2",
				data: {
					row: "notify",
					name: "__firing_process__notify__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-3",
				data: {
					row: "firing_order_with_contract",
					name: "__firing_process__firing_order_with_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-4",
				data: {
					row: "firing_order_finilizing",
					name: "__firing_process__finilizing__",
					is_position_related: false,
				},
			},
		],
	},
	{
		key: "2",
		data: {
			name: "__work_changes__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0-0",
				data: {
					row: "changes_report",
					name: "__hiring_process__changes_report__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-1",
				data: {
					row: "changes_additional_contract",
					name: "__hiring_process__changes_additional_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-2",
				data: {
					row: "changes_order",
					name: "__hiring_process__changes_order__",
					is_position_related: false,
				},
			},
		],
	},
	{
		key: "3",
		data: {
			name: "__procurement__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0-0",
				data: {
					row: "demand_letter",
					name: "__procurement__demand_letter__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-1",
				data: {
					row: "supplier_contract",
					name: "__procurement__supplier_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-2",
				data: {
					row: "additional_supplier_contract",
					name: "__procurement__additional_supplier_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-3",
				data: {
					row: "additional_contract",
					name: "__procurement__additional_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-4",
				data: {
					row: "act_of_acceptance",
					name: "__procurement__act_of_acceptance__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-5",
				data: {
					row: "additional_act",
					name: "__procurement__additional_act__",
					is_position_related: false,
				},
			},
		],
	},
	{
		key: "4",
		data: {
			name: "__service_procurement__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0-0",
				data: {
					row: "service_demand_letter",
					name: "__procurement__service_demand_letter__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-1",
				data: {
					row: "service_delivery_contract",
					name: "__procurement__service_delivery_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-2",
				data: {
					row: "additional_service_contract",
					name: "__procurement__additional_service_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-3",
				data: {
					row: "additional_service_acceptance",
					name: "__procurement__additional_service_acceptance__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-4",
				data: {
					row: "act_of_service_acceptance",
					name: "__procurement__act_of_service_acceptance__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-5",
				data: {
					row: "additional_act_of_service_acceptance",
					name: "__procurement__additional_act_of_service_acceptance__",
					is_position_related: false,
				},
			},
		],
	},
	{
		key: "5",
		data: {
			name: "__cable_procurement__",
			size: "200kb",
			type: "Folder",
		},
		children: [
			{
				key: "0-0-0",
				data: {
					row: "cable_contract",
					name: "__procurement__cable_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-1",
				data: {
					row: "additional_cable_contract",
					name: "__procurement__additional_cable_contract__",
					is_position_related: false,
				},
			},
			{
				key: "0-0-2",
				data: {
					row: "act_of_cable_acceptance",
					name: "__procurement__act_of_cable_acceptance__",
					is_position_related: false,
				},
			},
		],
	},
];
